export enum PrinterSideOption {
  simplex = 'simplex',
  duplex = 'duplex',
  duplexshort = 'duplexshort',
  duplexlong = 'duplexlong',
}
